document.addEventListener("DOMContentLoaded", () => {
    const readMoreButtons = document.querySelectorAll(".wp-block-klingit-basic-read-more-button");

    readMoreButtons.forEach(button => {
        const parent = button.closest(".wp-block-klingit-basic-read-more");
        const content = parent.querySelector(".wp-block-klingit-basic-read-more-content");

        button.addEventListener("click", () => {
            if (button.classList.contains("visible")) {
                button.classList.remove("visible");

                gsap.to(content, {
                    height: 0,
                    duration: Math.min(content.scrollHeight / 1000, .3),
                    ease: "Power3.easeOut",
                    onComplete: () => {
                        content.style.display = "none";
                    }
                });
            } else {
                button.classList.add("visible");
                content.style.display = "block";

                gsap.to(content, {
                    height: content.scrollHeight,
                    duration: Math.min(content.scrollHeight / 1000, .3),
                    ease: "Power3.easeIn",
                    onComplete: () => {
                        content.style.height = "auto";
                    }
                });
            }
        });
    });
});